import { VIRTUAL_RINGS } from 'business/tunnel/pages/ring-scan/constants';
import dayjs from 'dayjs';
import { useLiveQuery } from 'dexie-react-hooks';
import { useMemo } from 'react';
import { db, type Ring } from 'technical/db';

export const useRings = () => {
  const rings = useLiveQuery(() => db.rings.orderBy('number').toArray(), []);
  const sortedRings = useMemo(() => rings ?? [], [rings]);

  const maxRealRingNumber = useMemo(
    () => sortedRings[sortedRings.length - 1]?.number ?? 0,
    [sortedRings],
  );

  const virtualRings: Ring[] = useMemo(() => {
    const virtuals: Ring[] = [];
    for (let i = 1; i <= VIRTUAL_RINGS; i++) {
      virtuals.push({
        id: `virtualRing${i}`,
        createdAt: dayjs().toISOString(),
        number: maxRealRingNumber + i,
      });
    }
    return virtuals;
  }, [maxRealRingNumber]);

  const ringsWithVirtual = useMemo(
    () => [...sortedRings, ...virtualRings],
    [sortedRings, virtualRings],
  );

  return { rings: ringsWithVirtual, lastRealRingNumber: maxRealRingNumber };
};
